// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"431":"0882fffe","589":"2501a1c7","966":"b293a604"}[chunkId] + ".chunk.css";
};